export const useSystemColor = () => {
  const prefersDarkMode =
    typeof window !== `undefined`
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : null;

  return prefersDarkMode;
};
